import { __assign } from "tslib";
// DS: C59M
import React from 'react';
import { useTranslation } from 'react-i18next';
import MobileSharePopup from './MobileSharePopup';
import { getDeviationShareCodes } from '../helpers';
import { getTranslatedDeviationTitle, getDeviationResourceType, } from '../../DeviationViews/_helpers';
var MobileDeviationSharePopup = function (_a) {
    var deviation = _a.deviation, requestClose = _a.requestClose;
    var t = useTranslation().t;
    return (React.createElement(MobileSharePopup, __assign({ title: getTranslatedDeviationTitle(deviation, t), requestClose: requestClose, biData: {
            typeid: getDeviationResourceType(deviation),
            itemid: deviation.deviationId,
        } }, getDeviationShareCodes(deviation))));
};
MobileDeviationSharePopup.displayName = 'MobileDeviationSharePopup';
export default MobileDeviationSharePopup;
//# sourceMappingURL=MobileDeviationSharePopup.js.map